import { useReactFlow } from '@xyflow/react';

const ZOOM_DURATION = 1000;
export const ZOOM_OFFSET = 300;

export const useZoomTo = () => {
  const reactFlow = useReactFlow();

  return ({ x, y }: { x: number; y: number }) => {
    reactFlow.setCenter(x, y, {
      zoom: 1,
      duration: ZOOM_DURATION,
    });
  };
};
